<template>
  <header-app titlepage="دسته بندی ها" back="true"></header-app>

  <v-main class="main" >

    <category></category>

    <div class="clearfix"></div>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>

<script>
import { defineComponent } from 'vue';

// Components
import HelloWorld from '../components/HelloWorld.vue';
import AboutView from "@/views/AboutView.vue";
import HeaderApp from "@/views/headerApp.vue";
import PicLink from "@/components/PicLink.vue";
import FooterApp from "@/views/FooterApp.vue";
import Category from "@/components/Category.vue";
import Products from "@/components/Products.vue";

export default defineComponent({
  name: 'category-view',

  components: {
    Products,
    Category,
    FooterApp,
    PicLink,
    HeaderApp,
    HelloWorld,
  },
});
</script>

<style scoped>
.main{
  padding: 60px 0 60px;
  height: calc(100% +100px);
}
</style>
